import { PlaylistProps } from '@osmosis/shared/types/playlist';
import { tagSet } from '@osmosis/shared/quiz';

/**
 * Gets a playlist quiz url.
 *
 */
export const getPlaylistQuizUrl = (
  playlist: PlaylistProps,
  quizTag: string,
) => {
  return `/playlist-quiz/${playlist.url}/${tagSet[quizTag]?.url}`;
};
